'use client';

/**
 * DomainSearchPage.tsx — /domener/sok («Søk etter domener»)
 *
 * Hero med domenesøk og prischips, populære endelser som kort, «Slik velger du et godt
 * domenenavn» (nummererte tips), fordeler, promo til flytting, FAQ og avsluttende CTA.
 * Innhold: domain-shared.ts + domain-sok.ts; priser: domain-tlds.ts.
 */

import Capabilities from '@/components/landing/Capabilities';
import ClosingCta from '@/components/landing/ClosingCta';
import DomainHeroIllustration from '@/components/domain/DomainHeroIllustration';
import DomainPanelIllustration from '@/components/domain/DomainPanelIllustration';
import DomainSearch from '@/components/domain/DomainSearch';
import DomainShell from '@/components/domain/DomainShell';
import TldCards from '@/components/domain/TldCards';
import FaqAccordion from '@/components/product/FaqAccordion';
import NumberedSteps from '@/components/product/NumberedSteps';
import ProductHero from '@/components/product/ProductHero';
import PromoBanner from '@/components/product/PromoBanner';
import SectionNav from '@/components/product/SectionNav';
import { useLocale } from '@/hooks/useLocale';
import { DOMAIN_SHARED } from './domain-shared';
import { DOMAIN_SOK } from './domain-sok';
import { DOMAIN_POPULAR, DOMAIN_TLDS } from './domain-tlds';

export default function DomainSearchPage() {
  const { locale, setLocale } = useLocale();
  const shared = DOMAIN_SHARED[locale];
  const page = DOMAIN_SOK[locale];

  return (
    <DomainShell shared={shared} sectionNav={page.sectionNav} locale={locale} onLocaleChange={setLocale}>
      <ProductHero
        hero={page.hero}
        breadcrumb={page.breadcrumb}
        illustration={<DomainHeroIllustration label={page.hero.illustrationLabel} />}
        extra={<DomainSearch search={shared.search} tlds={DOMAIN_TLDS} currency={shared.currency} />}
      />
      <SectionNav nav={page.sectionNav} />
      <TldCards id="endelser" content={page.popular} items={DOMAIN_POPULAR} currency={shared.currency} tag={shared.labels.popular} />
      <NumberedSteps id="tips" steps={page.tips} art={<DomainPanelIllustration label={page.tips.panelLabel} />} />
      <Capabilities capabilities={shared.why} id="hvorfor" />
      <PromoBanner promo={page.promo} />
      <FaqAccordion faq={page.faq} />
      <ClosingCta cta={page.cta} />
    </DomainShell>
  );
}
